import { useQueryClient } from '@tanstack/react-query';
import { Button, useToast } from '@vd/ui';
import { api } from '../../lib/api';
import { WHATS_NEW } from './whatsNew';
import { WhatsNewArt } from './WhatsNewArt';
import styles from './DashboardSections.module.css';

/**
 * What's new in Toado (TOADO-731), until the person dismisses this release's
 * list. `dismissed` is the release they last dismissed, from home state.
 */
export function WhatsNewCard({ dismissed, companyId }: { dismissed: string | null | undefined; companyId: string | null }) {
  const qc = useQueryClient();
  const toast = useToast();
  if (dismissed === WHATS_NEW.release) return null;
  const dismiss = async () => {
    // Gone at once; the server's answer settles it.
    qc.setQueryData(['home-state', companyId], (old: Record<string, unknown> | undefined) => (old ? { ...old, whatsNewDismissed: WHATS_NEW.release } : old));
    try {
      await api.dismissWhatsNew(WHATS_NEW.release);
    } catch (e) {
      toast.push({ variant: 'danger', title: "Could not dismiss What's new", description: (e as Error).message });
    }
    await qc.invalidateQueries({ queryKey: ['home-state'] });
  };
  return (
    <section className={`${styles.card} ${styles.whatsNewCard}`} data-testid="dash-whats-new" aria-label="What's new in Toado">
      <header className={styles.cardHead}>
        <h2 className={styles.cardTitle}>What's new in Toado {WHATS_NEW.release}</h2>
        <Button variant="ghost" size="sm" onClick={dismiss}>Dismiss</Button>
      </header>
      {/* The list on the left, the drawing on the right; on a narrow card the drawing goes below (TOADO-859). */}
      <div className={styles.whatsNewBody}>
        <div>
          <ul className={styles.whatsNew}>
            {WHATS_NEW.items.map((item) => <li key={item}>{item}</li>)}
          </ul>
          {WHATS_NEW.notesUrl && (
            <a className={styles.more} href={WHATS_NEW.notesUrl} target="_blank" rel="noreferrer">Read the full notes</a>
          )}
        </div>
        <WhatsNewArt />
      </div>
    </section>
  );
}
